import { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';
export const footerData: PageData = [
  {
    formId: 'form1',
    heading: 'Footer Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'joinButtonText', label: 'Join now button text', type: 'input' },
      { id: 'joinButtonLink', label: 'Join now button link', type: 'input' },
      { id: 'contactButtonText', label: 'Contact us button text', type: 'input' },
      { id: 'contactButtonLink', label: 'Contact us button link', type: 'input' },
      {
        id: 'logo',
        label: 'Company logo',
        info: getIdealImageSize(195, 72),
        type: 'image',
        backgroundColor: 'black'
      },
      { id: 'content', label: 'Description', type: 'textarea' },
      { id: 'email', label: 'Email address', type: 'input' },
      { id: 'copyright', label: 'Copyright text', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Social Media section',
    data: [
      {
        id: 'socialMediaIcon',
        label: 'Social media icon',
        info: getIdealImageSize(24, 24),
        type: 'image'
      },
      { id: 'socialMediaLink', label: 'Social media link URL', type: 'input' }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Footer Columns',
    data: [
      { id: 'columnTitle', label: 'Column Title', type: 'input' }
    ],
    nested: {
      heading: 'Column Links',
      data: [
        { id: 'linkLabel', label: 'Link Label', type: 'input' },
        { id: 'linkUrl', label: 'Link URL', type: 'input' }
      ]
    }
  },
  {
    formId: 'formGroup3',
    heading: 'Legal Links (Bottom Right)',
    data: [
      { id: 'linkLabel', label: 'Link Label', type: 'input' },
      { id: 'linkUrl', label: 'Link URL', type: 'input' }
    ]
  }
];
